import React from 'react';

import { UserActionIndicatorChangers, UserActionIndicators } from '../types/user-action-indicator';

export const CurrentUserActionIndicatorContext = React.createContext<UserActionIndicators | null>(
    null
);
export const UserActionIndicatorChangerContext =
    React.createContext<UserActionIndicatorChangers | null>(null);
